import { memo, useContext } from 'react';
import { css } from '@linaria/atomic';
import { Handle, Position } from '@xyflow/react';
import { useTranslation } from '@frontend/i18n';
import { Button, useTooltip } from '@frontend/design-system';
import { SharedNodeProps } from '../data';
import { InteractionContext } from '../provider';
import { useWarningDismissal } from '../warning-dismissal-provider';
import { WarningTooltip } from './warning-tooltip';

const componentDivStyle1 = css`
  position: relative;
`;

const componentButtonStyle2 = css`
  position: relative;
  bottom: 4px;
`;

const componentTooltipStyle3 = css`
  font-weight: 400;
`;

export const PlaceholderNode = memo(({ data }: SharedNodeProps) => {
  const { t } = useTranslation('phone');
  const { isDismissed, dismissWarning } = useWarningDismissal();
  const showWarning = !!data.warning && !isDismissed(data.id);

  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'right' });

  const { onPlusIconClick } = useContext(InteractionContext);

  return (
    <>
      <Handle
        type='target'
        position={Position.Top}
        id={`${data.id}-top`}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />
      <div className={componentDivStyle1}>
        <Button
          variant='secondary'
          {...(!showWarning ? triggerProps : {})}
          onClick={() => onPlusIconClick?.({ parentNodeId: data.parentId ?? '' })}
          className={componentButtonStyle2}
          iconName='plus'
        ></Button>

        {showWarning && (
          <WarningTooltip message={t(data.warning as string)} onDismiss={() => dismissWarning(data.id)} />
        )}
      </div>

      <Handle
        type='source'
        position={Position.Bottom}
        id={`${data.id}-bottom`}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />

      {!showWarning && (
        <Tooltip {...tooltipProps} className={componentTooltipStyle3}>
          {t('Add step')}
        </Tooltip>
      )}
    </>
  );
});
PlaceholderNode.displayName = 'PlaceholderNode';
